import type { LucideIcon } from "lucide-react";
import {
  Zap,
  Clock,
  FileText,
  Mic,
  MessageSquare,
  Mail,
  PenLine,
  Headphones,
  Code2,
  Music2,
  Users,
} from "lucide-react";

export interface PlanFeature {
  icon: LucideIcon;
  text: string;
  highlight?: string;
  category: "Usage" | "Input Sources" | "Audio & Voice" | "Support";
}

// Re-exported with a different name so the i18n-aware Pricing component can
// build the same structure but populate `text` / `highlight` via t(...) calls
// instead of consuming the hard-coded English HOBBY_FEATURES array below.
export type PlanFeatureRow = PlanFeature;

export const HOBBY_FEATURE_ICONS = {
  feat1: Zap,
  feat2: Clock,
  feat3: FileText,
  feat4: Headphones,
  feat5: Code2,
  feat6: Mail,
  feat7: Music2,
  feat8: Users,
  feat9: Mic,
} as const;

export const FREE_FEATURES: PlanFeature[] = [
  { icon: Zap, text: "1,900 audio characters", category: "Usage" },
  { icon: Clock, text: "Short clips (1 min max)", category: "Usage" },
  { icon: FileText, text: "Text input only", category: "Input Sources" },
  { icon: Mic, text: "6 standard voices", category: "Audio & Voice" },
  { icon: MessageSquare, text: "Control tone with emoji", category: "Audio & Voice" },
  { icon: PenLine, text: "Full transcript editing", category: "Audio & Voice" },
  { icon: MessageSquare, text: "Community FAQ", category: "Support" },
];

export const HOBBY_FEATURES: PlanFeature[] = [
  { icon: Zap, text: "170,000 audio characters / month", highlight: "Massive monthly quota", category: "Usage" },
  { icon: Clock, text: "Up to 25 minutes per podcast", category: "Usage" },
  { icon: FileText, text: "All sources: Text, PDF, URL, Image", category: "Input Sources" },
  { icon: Headphones, text: "Full voice library", highlight: "Unlocks 20+ premium voices", category: "Audio & Voice" },
  { icon: Mic, text: "Voice cloning — 2 custom voices", highlight: "Clone your own voice", category: "Audio & Voice" },
  { icon: Code2, text: "Embed your podcasts on any website", highlight: "One-line iframe snippet", category: "Audio & Voice" },
  { icon: Mail, text: "Priority email support",category: "Support" },
];
